module.exports = __webpack_public_path__ + "img/laptop_skin_much_smaller_skills.c510391d.svg";